import whiteLogo from "../assest/images/whitelogo.png";
import visaLogo from "../assest/images/Visa_new.png";
import mastercardLogo from "../assest/images/Mastercard_new.png";
import paypalLogo from "../assest/images/PayPal_new.png";
import applePayLogo from "../assest/images/ApplePay_new.png";
import bitcoinLogo from "../assest/images/Bitcoin_new.png";
import googlePayLogo from "../assest/images/GooglePay_new.png";
import unionPayLogo from "../assest/images/UnionPay_new.png";
import giropayLogo from "../assest/images/Giropay_new.png";
import idealLogo from "../assest/images/Ideal_new.png";
import bancontactLogo from "../assest/images/Bancontact_new.png";
import ApiCall from "../common/ApiCall";
import { useEffect, useState } from "react";
import FooterLocationList from "./Skeletons/FooterLocationList";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setFooterLocations } from "../redux/global/global.action";
import helper, { getSlugByLang, getSlugNameByLang } from "../common/Helper";
import { footerSocialUrl } from "../common/Config";
import moment from "moment";
import Cookie from "./Cookie";
import noTour from "../assest/myImages/no-tour-img.png";


const Footer = () => {
    const [locationList, setLocationList] = useState([])
    const [footerSettings, setFooterSettings] = useState([])
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const global = useSelector((state) => state.global);
    const user = useSelector((state) => state.user);
    const userlang = getSlugByLang(user?.language);
    const slugName = getSlugNameByLang(user?.language);

    let footerLocationStoreTime = global.footerLocationStoreTime;

    const getLocationList = async () => {
        setLoading(true)
        const getList = await ApiCall('get', 'footer-locations')
        setLoading(false)
        if (getList) {
            if (getList?.data?.success) {
                setLocationList(getList.data.data)
                // setFooterSettings(getList.data.settings)
                dispatch(setFooterLocations(JSON.stringify(getList.data.data)))
            }
        }
    }

    const getSettingsList = async () => {
        setLoading(true)
        const getList = await ApiCall('get', 'footer-settings')
        setLoading(false)
        if (getList) {
            if (getList?.data?.success) {
                setFooterSettings(getList?.data?.settings)
            }
        }
    }


    useEffect(() => {
        // const currentTimestamp = Date.now();
        const lastFetchDate = footerLocationStoreTime ? new Date(footerLocationStoreTime).toDateString() : null;  // Last fetch date as a string
        // Store time from state
        const currentDate = new Date().toDateString();  // Current date as a string

        // Check if more than 24 hours have passed since the last fetch
        if (!footerLocationStoreTime || lastFetchDate !== currentDate) {
            (async () => {
                await getLocationList();
            })();
        } else {

            setLocationList(JSON.parse(global.footerLocations));
        }
    }, [footerLocationStoreTime]);

    useEffect(() => {
        (async () => {
            await getSettingsList();
        })();
    }, []);

    const paymentMethods = [
        { src: visaLogo, alt: 'Visa' },
        { src: mastercardLogo, alt: 'Mastercard' },
        { src: paypalLogo, alt: 'PayPal' },
        { src: applePayLogo, alt: 'Apple Pay' },
        { src: bitcoinLogo, alt: 'Bitcoin' },
        { src: googlePayLogo, alt: 'Google Pay' },
        { src: unionPayLogo, alt: 'Union Pay' },
        { src: giropayLogo, alt: 'Giropay' },
        { src: idealLogo, alt: 'Ideal' },
        { src: bancontactLogo, alt: 'Bancontact' }
    ];

    const socialFields = Object.fromEntries(
        Object.entries(footerSettings).filter(([key]) => key.startsWith("footer_social_"))
    );
    const supportSlug = {
        'About Us': (userlang ? '/' + userlang : '') + '/about-us',
        'Blog': (userlang ? '/' + userlang : '') + '/blog',
        'Contact Us': (userlang ? '/' + userlang : '') + '/contact-us',
        'FAQ': (userlang ? '/' + userlang : '') + '/faqs',
        'Terms and Conditions': (userlang ? '/' + userlang : '') + '/terms-and-conditions',
    }

    return (
        <>
            <Cookie />
            <footer>
                <div className="footerPart">
                    <div className="container">
                        <div className="footerBox">
                            <div className="innerBox">
                                <div className="row">
                                    <div className="col-3">
                                        <div className="footermenu logoFooter">
                                            <div className="logoImg">
                                                <a href="javascript:void(0)">
                                                    <img src={whiteLogo} alt="White Logo" />
                                                </a>
                                                {
                                                    loading == true ?
                                                        <p className={'skeleton'}>
                                                            KMG – MOBILIDADE URBANA, S.A If you have an inquiry or would like more information about any of our tours, please use the contact form below! We will get back to you within 24 hours.
                                                        </p> :
                                                        <p >
                                                            {footerSettings['footer_description']}
                                                        </p>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-7">
                                        <div className="row">
                                            {
                                                loading ? <FooterLocationList records={3} /> :
                                                    locationList.map((location, index) => (
                                                        <div className="col-3" key={index}>
                                                            <div className="footermenu firstBox">
                                                                <Link to={(userlang ? '/' + userlang : '') + '/location/' + location?.[slugName]} style={{ color: "#888e9d", marginBottom: '1rem' }}>{location.name}</Link>
                                                                <ul>
                                                                    {
                                                                        location?.children.map((child, i) => {
                                                                            return (
                                                                                <li key={i}><Link to={(userlang ? '/' + userlang : '') + '/location/' + location?.[slugName] + '/' + child?.[slugName]}>{child.name}</Link></li>
                                                                            )
                                                                        })
                                                                    }
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    ))
                                            }
                                            {
                                                loading ? <FooterLocationList records={1} /> :
                                                    footerSettings && footerSettings['footer_supports'] != "" &&
                                                    footerSettings['footer_supports'] &&
                                                    JSON.parse(footerSettings['footer_supports']).length > 0 &&

                                                    <div className="col-3">
                                                        <div className="footermenu fourBox">
                                                            <p>Support</p>
                                                            <ul>
                                                                {
                                                                    footerSettings && footerSettings['footer_supports'] != "" &&
                                                                    footerSettings['footer_supports'] &&
                                                                    JSON.parse(footerSettings['footer_supports']).length > 0 &&
                                                                    JSON.parse(footerSettings['footer_supports']).map((ftr, alt) => (

                                                                        ftr.checked == true &&
                                                                        <li key={alt}><Link to={supportSlug[ftr?.name]}>{ftr?.name}</Link></li>
                                                                    ))
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                            }
                                        </div>
                                    </div>

                                    {
                                        loading ?

                                            <div className="col-2">
                                                <div className="footermenu fiveBox">
                                                    <p>Pay With</p>
                                                    <ul>
                                                        {
                                                            loading &&
                                                            paymentMethods.map(({ src, alt }) => (
                                                                <li key={alt}>
                                                                    <span className="skeleton" style={{ display: 'inline-block', fontSize: "14px" }}>
                                                                        <img src={src} alt={alt} loading="lazy" onError={(e) => {
                                                                            e.target.onerror = null;
                                                                            e.target.src = noTour
                                                                        }} />
                                                                    </span>
                                                                </li>
                                                            ))
                                                        }
                                                        {/* {
                                                !loading &&
                                                footerSettings && footerSettings['footer_icons'] != "" &&
                                                footerSettings['footer_icons'] &&
                                                JSON.parse(footerSettings['footer_icons']).length > 0 &&
                                                JSON.parse(footerSettings['footer_icons']).map((src, alt) => (
                                                    <li key={alt}>
                                                        <span style={{ display: 'inline-block', fontSize: "14px" }}>
                                                            <img src={helper.S3Url + '/' + helper.footerImageDir + '/' + src} alt={alt} loading="lazy" />
                                                        </span>
                                                    </li>
                                                ))
                                            } */}
                                                    </ul>
                                                </div>
                                            </div> :
                                            footerSettings['footer_icons'] &&
                                            JSON.parse(footerSettings['footer_icons']).length > 0 &&
                                            <div className="col-2">
                                                <div className="footermenu fiveBox">
                                                    <p>Pay With</p>
                                                    <ul>
                                                        {/* {
                                                loading &&
                                                paymentMethods.map(({ src, alt }) => (
                                                    <li key={alt}>
                                                        <span className="skeleton" style={{ display: 'inline-block', fontSize: "14px" }}>
                                                            <img src={src} alt={alt} loading="lazy" />
                                                        </span>
                                                    </li>
                                                ))
                                            } */}
                                                        {
                                                            !loading &&
                                                            footerSettings && footerSettings['footer_icons'] != "" &&
                                                            footerSettings['footer_icons'] &&
                                                            JSON.parse(footerSettings['footer_icons']).length > 0 &&
                                                            JSON.parse(footerSettings['footer_icons']).map((src, alt) => (
                                                                <li key={alt}>
                                                                    <span style={{ display: 'inline-block', fontSize: "14px" }}>
                                                                        <img src={helper.S3Url + '/' + helper.footerImageDir + '/' + src} alt={alt}
                                                                            onError={(e) => {
                                                                                e.target.onerror = null;
                                                                                e.target.src = noTour
                                                                            }} />
                                                                    </span>
                                                                </li>
                                                            ))
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                    }
                                </div>
                            </div>
                            <div className="copyRight">
                                {/* <p>Copyright © {moment().format('Y')}. All rights reserved</p> */}
                                {/* <p>{footerSettings['footer_copyrights']}</p> */}
                                <p>{footerSettings['footer_copyrights']?.replace('[YEAR]', moment().format('YYYY'))}</p>
                                {
                                    loading &&

                                    <div className="iconBox">
                                        <ul>
                                            <li className="skeleton"><a target="_blank" href="https://www.facebook.com/toursXplorer"><i className="fa-brands fa-facebook-f"></i></a></li>
                                            <li className="skeleton"><a target="_blank" href="https://twitter.com/Tours_xplorer"><i className="fa-brands fa-twitter"></i></a></li>
                                            <li className="skeleton"><a target="_blank" href="https://t.me/toursXplorer"><i className="fa-brands fa-telegram"></i></a></li>
                                            <li className="skeleton"><a target="_blank" href="https://www.instagram.com/toursxplorer/"><i className="fa-brands fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                }
                                {
                                    !loading &&
                                    Object.entries(socialFields).length > 0 &&
                                    <div className="iconBox">
                                        <ul>
                                            {
                                                Object.entries(socialFields).map((v, k) => {
                                                    return (
                                                        v[1] != "" && v[1] != null &&
                                                        <li key={k}>
                                                            <a target="_blank"
                                                                href={v[0] == 'footer_social_twitter_username' ? 'https://x.com/' + v[1] : v[1]}>
                                                                {footerSocialUrl[v[0]]}
                                                            </a></li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )

}
export default Footer